<template>
  <div>
    <el-table border v-loading="listLoading" :data="list" :element-loading-text="elementLoadingText" @row-dblclick="rowdbClick" max-height="650" :header-cell-style="{background: 'linear-gradient(#6cb3ff, #1873d4)',color:'#eeeeee'}">
      <el-table-column type="index" width="40" align="center"></el-table-column>

      <el-table-column show-overflow-tooltip align="center" label="充值类别">
        <el-table-column show-overflow-tooltip align="center" min-width="100" prop="rechargeTypeNum" label="编码"></el-table-column>
        <el-table-column show-overflow-tooltip align="center" min-width="100" prop="rechargeTypeName" label="名称"></el-table-column>
        <el-table-column show-overflow-tooltip align="center" min-width="160" prop="cardRechargeMoney" label="金额"></el-table-column>
        <el-table-column show-overflow-tooltip align="center" min-width="160" prop="discount" label="折扣"></el-table-column>
      </el-table-column>
      <el-table-column show-overflow-tooltip align="center" label="充值">
        <el-table-column show-overflow-tooltip align="center" min-width="100" prop="cardRestMoney" label="剩余"></el-table-column>
        <el-table-column show-overflow-tooltip align="center" min-width="100" prop="cardConsumeMoney" label="可用"></el-table-column>
      </el-table-column>
      <!-- <el-table-column show-overflow-tooltip align="center" label="赠送"> -->
        <el-table-column show-overflow-tooltip align="center" min-width="100" prop="cardGiftMoney" label="赠送剩余">
          <template slot-scope="scope">
            <el-tooltip placement="top" v-if="scope.row.rechargeAccountGiveList.length">
              <div slot="content" v-for="item in scope.row.rechargeAccountGiveList" :key="item.id">
                  {{ item.storeName }}:{{ item.giftConsumeMoney }}<br/>
              </div>
              <span>{{ scope.row.cardGiftMoney }}</span>
            </el-tooltip>
            <span v-else>{{ scope.row.cardGiftMoney }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column show-overflow-tooltip align="center" min-width="100" prop="giftConsumeMoney" label="可用"></el-table-column> -->
      <!-- </el-table-column> -->
      <el-table-column show-overflow-tooltip align="center" min-width="100" prop="endTime" sortable label="到期时间"></el-table-column>
    </el-table>
    <detail ref="detail"></detail>
  </div>
</template>

<script>
import { recAccountCashList } from "@/api/eashier.js";
import detail from "./recdetail";
export default {
  components: { detail },
  data() {
    return {
      form: {}, //主对象
      list: [], //主数组
      total: 0, //分页总条数
      listLoading: false, //list加载提示开启动画
      elementLoadingText: "加载中...", //list加载提示文字
      queryForm: {
        //查询对象
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  methods: {
    //列表数组双击方法
    rowdbClick(row) {
      this.$refs.detail.show(row);
    },
    //组件传值
    show(form) {
      this.form = { ...form };
      this.getData();
    },
    //分页方法
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.getData();
      //console.log(val);
    },
    handleCurrentChange(val) {
      this.queryForm.pageNum = val;
      this.getData();
      //console.log(val);
    },
    //获取数据
    async getData() {
      recAccountCashList({
        memberId: this.form.id,
      }).then((res) => {
        if (res.code == "000000") {
          this.list = res.rows;
        } else {
          this.$alert(res.message, "查询会员卡包", {
            confirmButtonText: "确定",
            confirmButtonClass: "confirmbtnFalses",
            type: "warning",
            center: true,
            callback: (action) => {},
          });
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/trading/components/rec.vue